import React from "react"
import { useTranslation } from "react-i18next"
import Textarea from "../input/Textarea"
import PropTypes from 'prop-types';

const Message = ({ required = true, ...props }) => {
  const { t, i18n } = useTranslation("forms")

  const requiredError = i18n.exists("forms:inputs.message.errors.required") ? t("inputs.message.errors.required") : t("inputsGenerics.requiredError")

  return <Textarea label={t("inputs.message.label")} name="message" required={required ? requiredError : false} {...props} />
}

Message.propTypes = {
  required: PropTypes.string
}

export default Message